import styled from 'styled-components';
import { responsive } from '../../themes/style';

export const StyleContainer = styled('div')({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
});

export const Content = styled('div')({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '48px 16px',
});

export const HeaderBar = styled('header')({
  height: 56,
  display: 'flex',
  alignItems: 'center',
  padding: '0 16px',
});

export const Brand = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
});

export const BrandDot = styled('div')({
  width: 28,
  height: 28,
  borderRadius: 999,
  background: '#e74c3c',
  color: '#fff',
  display: 'grid',
  placeItems: 'center',
  fontWeight: 700,
  fontSize: 14,
});

export const Card = styled('div')({
  width: 'min(520px, 100%)',
  background: '#fff',
  borderRadius: 12,
  boxShadow: '0 10px 24px rgba(0, 0, 0, 0.08)',
  padding: '28px 28px 22px',
});

export const IconCircle = styled('div')({
  width: 44,
  height: 44,
  borderRadius: 999,
  background: '#fdeaea',
  color: '#e74c3c',
  display: 'grid',
  placeItems: 'center',
  fontWeight: 800,
  fontSize: 18,
  border: '2px solid rgba(231, 76, 60, 0.35)',
});

export const Divider = styled('div')({
  width: 56,
  height: 3,
  background: '#e74c3c',
  borderRadius: 999,
  margin: '14px auto 0',
});

export const TimeLabel = styled('div')({
  color: '#e74c3c',
  marginBottom: 8,
});

export const TimeMain = styled('div')({
  color: '#e74c3c',
  marginBottom: 4,
});

export const TimeSub = styled('div')({
  color: '#e74c3c',
});

export const StyledHeader = styled('header')({
  justifyContent: 'flex-start',
  alignItems: 'center',
  display: 'flex',
  backgroundColor: 'var(--white-color)',
  borderBottom: '1px solid var(--border-color)',
  padding: '5px 30px',
  minHeight: 90,

  [responsive('max', 'smartphone')]: {
    minHeight: 60,
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 100,
  },
});

export const TimeBox = styled('div')({
  border: '1px solid rgba(231, 76, 60, 0.45)',
  background: '#FDEAEA',
  borderRadius: 10,
  padding: '16px 14px',
  textAlign: 'center',

  color: '#E74C3C',
  '& *': {
    color: '#E74C3C !important',
  },
});
